const widgets = {
  editMode: "עריכה",
  guideMode: "מדריך",
  library: "ספריית ווידג'טים",
  size: "גודל",
  hoverDelay: "השהיית ריחוף",
  none: "ללא",
  seconds: "שניות",
  showWidget: "הצג",
  hideWidget: "הסתר",
  comingSoon: "בקרוב",
  noWidgets: "אין ווידג'טים פעילים",
  addWidgets: "הוסף ווידג'טים",
  close: "סגור",
  resetSize: "אפס גודל",
  search: "חיפוש",
  searchPlaceholder: "חיפוש פרויקטים, מסמכים...",
  recent: "אחרונים",
  recentSearches: "חיפושים אחרונים",
  quickActions: "פעולות מהירות",
  newProject: "צור פרויקט חדש",
  newDocument: "מסמך חדש",
  newTask: "משימה חדשה",
  noResults: "אין תוצאות",
  // Command Palette sections
  commandsSection: "פעולות",
  pagesSection: "דפים",
  widgetsSection: "ווידג'טים",
  projectsSection: "פרויקטים",
  wikiSection: "ויקי",
  typeCommandHint: "הקלד > לפקודות, / לדפים",
  // Apps Manager tab
  searchTab: "חיפוש",
  appsTab: "אפליקציות",
  appsOnToolbar: "בסרגל",
  appsInDrawer: "באפליקציות",
  appsDisabled: "כבוי",
  appsAddToToolbar: "הוסף לסרגל",
  appsRemoveFromToolbar: "הסר מהסרגל",
  appsMoveToApps: "העבר לאפליקציות",
  appsDisableWidget: "כבה ווידג'ט",
  appsActiveWidgets: "ווידג'טים פעילים",
  appsAllWidgets: "כל הווידג'טים",
  appsComingSoon: "בקרוב",
  projects: "פרויקטים",
  documents: "מסמכים",
  conversations: "שיחות AI",
  aiAssistant: "עוזר AI",
  aiDescription: "עוזר AI מהיר עם הקשר לעמוד",
  ask: "שאל...",
  context: "הקשר",
  addContext: "הוסף הקשר",
  sendMessage: "שלח",
  typePlaceholder: "שאל שאלה...",
  suggestSummarize: "סכם את מצב הפרויקטים",
  suggestAttention: "מה דורש תשומת לב?",
  suggestWrite: "עזור לכתוב",
  suggestFix: "תקן שגיאות",
  suggestSummarizeDoc: "סכם את המסמך",
  suggestToday: "מה יש היום?",
  suggestNewProject: "צור פרויקט חדש",
  sidePanel: "פאנל צד",
  miniWindow: "חלון קטן",
  floatingChat: "צ'אט צף",
  quickCreate: "יצירה מהירה",
  quickCreateDesc: "צור מסמך או ישות חדשה",
  newEntity: "ישות חדשה",
  new: "חדש",
  newDocAction: "מסמך חדש",
  newFormalDoc: "מסמך רשמי",
  newProjectAction: "פרויקט חדש",
  newTaskAction: "משימה חדשה",
  create: "צור",
  titlePlaceholder: "שם...",
  createdToday: "נוצרו היום",
  favorites: "מועדפים",
  favoritesDesc: "דפים וקישורים שנשמרו",
  addFavorite: "הוסף מועדף",
  pinPage: "הצמד דף",
  unpinPage: "בטל הצמדה",
  noFavorites: "אין מועדפים",
  todayWidget: "היום",
  todayDesc: "פגישות, דדליינים ותזכורות",
  meetings: "פגישות",
  deadlines: "דדליינים",
  reminders: "תזכורות",
  noEvents: "אין אירועים היום",
  // Notifications
  notifications: "התראות",
  notificationsDesc: "התראות מפרויקטים, מסמכים ו-AI",
  markAllRead: "סמן הכל כנקרא",
  noNotifications: "אין התראות",
  unread: "לא נקראו",
  // Timer
  timer: "טיימר",
  timerDesc: "טיימר פומודורו לניהול זמן",
  timerWork: "עבודה",
  timerBreak: "הפסקה",
  timerLongBreak: "הפסקה ארוכה",
  timerStart: "התחל",
  timerPause: "עצור",
  timerReset: "אפס",
  timerSessions: "סשנים",
  // Clipboard
  clipboard: "לוח הדבקות",
  clipboardDesc: "פריטים שהועתקו לאחרונה",
  clearAll: "נקה הכל",
  noClipboardItems: "אין פריטים",
  copied: "הועתק",
  clipboardItems: "פריטים",
  activeWidgets: "פעילים",
  comingSoonWidgets: "בקרוב",
  // Keyboard Shortcuts
  keyboardShortcuts: "קיצורי מקלדת",
  keyboardShortcutsDesc: "קיצורי מקלדת וניהול פעולות",
  shortcutsSearch: "חפש קיצור...",
  shortcutsActive: "פעילים",
  shortcutsAll: "הכל",
  shortcutsNoResults: "לא נמצאו קיצורים",
  shortcutsAddCustom: "הוסף קיצור מותאם",
  shortcutsEdit: "ערוך",
  shortcutsDelete: "מחק",
  shortcutsConflict: "קונפליקט — קיצור זה כבר בשימוש",
  shortcutsReset: "אפס לברירת מחדל",
  shortcutsSystem: "מערכת",
  shortcutsCustom: "מותאם אישית",
  shortcutsEnabled: "פעיל",
  shortcutsDisabled: "מושבת",
  shortcutsAiSuggest: "תאר פעולה שתרצה לקצר...",
  shortcutsAiPlaceholder: "הקלד ולחץ Enter — AI יציע קיצור מקלדת",
  shortcutsKeyCombo: "צירוף מקשים",
  shortcutsActionName: "שם הפעולה",
  shortcutsScope: "תחום",
  shortcutsScopeGlobal: "גלובלי",
  shortcutsScopeEditor: "עורך",
  shortcutsScopeCardBrowser: "דפדפן כרטיסים",
  shortcutsScopeTable: "טבלה",
  shortcutsReserved: "שמור למערכת",
  // Common widget strings
  allClear: "אין חדשות",
  soon: "בקרוב",
  savedLocally: "שמור מקומית",
  langFlag: "עב",
  // Weekly Planner
  weeklyPlanner: "סדר שבועי",
  weeklyPlannerDesc: "תכנון שבועי, משימות יומיות ותבניות חוזרות",
  plannerToday: "היום",
  plannerPersonal: "שלי",
  plannerTeam: "צוות",
  plannerAll: "הכל",
  plannerTasks: "משימות",
  plannerUrgent: "דחופות",
  plannerMeetings: "פגישות",
  plannerMember: "עובד",
  plannerTemplates: "תבניות שבועיות",
  plannerApply: "החל",
  plannerFreeDay: "יום פנוי 🎉",
  plannerAdd: "הוסף",
  plannerDone: "בוצע",
  plannerMoveToTomorrow: "העבר למחר",
  plannerDelete: "מחק",
  plannerNewTemplate: "שם תבנית חדשה...",
  plannerCreate: "צור",
  plannerAddItem: "הוסף פריט",
  plannerNoItems: "אין פריטים. הוסף פריטים לתבנית.",
  plannerTaskPlaceholder: "משימה + שעה...",
  plannerCancel: "ביטול",
  plannerAssignMe: "👤 מוקצה לי",
  plannerNone: "ללא",
  plannerMe: "אני",
  plannerFree: "פנוי",
  plannerTitlePlaceholder: "כותרת...",
  plannerApplyToWeek: "החל על השבוע",
  plannerTemplateDesc: "צור תבנית שבועית עם משימות חוזרות. החל על השבוע הנוכחי בלחיצה.",
  plannerAddTask: "הוסף משימה",
  plannerPriorityUrgent: "דחוף",
  plannerPriorityImportant: "חשוב",
  plannerPriorityNormal: "רגיל",
  plannerAddToTemplate: "הוסף פריט לתבנית",
  // AppStore / Widget settings
  categoryAll: "הכל",
  selectWidgetToConfigure: "בחר ווידג׳ט לצפייה בהגדרות",
  widgetPlacement: "מיקום",
  widgetSize: "גודל",
  widgetActive: "פעיל",
  widgetComingSoon: "בקרוב",
  widgetLocked: "נעול",
  widgetUnlocked: "פתוח",
  // Search
  semanticResults: "תוצאות סמנטיות",
  searchNavigate: "ניווט",
  searchSelect: "בחירה",
  searchClose: "סגירה",
  untitled: "ללא כותרת",
  // Settings folder
  allSettings: "כל ההגדרות",
  storeSystem: "מערכת",
  storeFolders: "תיקיות",
  storeCreateFolder: "צור תיקיה",
  storeActiveCount: "פעילים",
  // Widget Store
  store: "חנות תוספים",
  storeSearch: "חפש ווידג'טים...",
  storeTabInstalled: "מותקנים",
  storeTabAvailable: "זמינים",
  storeTabComingSoon: "בקרוב",
  storeBack: "חזרה לחנות",
  storePlacement: "מיקום",
  storeSystemWidget: "ווידג'ט מערכת — לא ניתן להשבית.",
  storeNotifyMe: "עדכן אותי",
  storeNoResults: "לא נמצאו ווידג'טים",
  // Placements
  placementToolbar: "סרגל עליון",
  placementApps: "אפליקציות",
  placementDisabled: "מושבת",
  placementDescToolbar: "הווידג'ט מוצג בסרגל העליון ותמיד נגיש.",
  placementDescApps: "הווידג'ט פעיל אבל נגיש רק דרך מגירת האפליקציות.",
  placementDescDisabled: "הווידג'ט כבוי לחלוטין. ללא שימוש במשאבים.",
  // Categories
  categoryBasics: "בסיסיים",
  categoryProductivity: "פרודוקטיביות",
  categoryAiComms: "AI ותקשורת",
  categoryTeam: "צוות",
  categoryAnalytics: "אנליטיקס",
  categoryIntegrations: "אינטגרציות",
  // Apps Drawer
  appsDrawer: "אפליקציות",
  appsEmpty: "אין אפליקציות כאן עדיין. העבר ווידג'טים ל-'אפליקציות' בחנות.",
  appsHint: "ווידג'טים במיקום אפליקציות מוצגים כאן.",
  // Custom Labels
  customLabel: "שם מותאם",
  resetLabel: "אפס שם",
  // Profile Switcher
  profileSwitcher: "מחליף פרופילים",
  switchProfile: "החלף פרופיל",
  saveAsNew: "שמור כחדש",
  profileName: "שם פרופיל...",
  // Display Modes
  displayMode: "מצב תצוגה",
  displayNormal: "רגיל",
  displayCompact: "קומפקטי",
  displayIconsOnly: "אייקונים בלבד",
  // Auto-Pack
  autoPack: "ארגן",
  // Panel Modes
  panelMode: "מצב פאנל",
  panelModeDropdown: "נפתח",
  panelModeSidePanel: "פאנל צד",
  panelModePopup: "חלון קופץ",
  // Quick Bookmark
  quickBookmark: "סימנייה מהירה",
  bookmarkAdded: "נוסף לסימניות",
  openNote: "פתח הערה",
  // KPI Widget
  kpiOpenProjects: "פרויקטים פתוחים",
  kpiDocuments: "מסמכים",
  kpiActivity7d: "פעילות (7 ימים)",
  kpiAvgHealth: "בריאות ממוצעת",
  kpiQuickMetrics: "מדדים מהירים",
  kpiBar: "מדדים",
  // Leads Pipeline Widget
  leadsPipeline: "צנרת לידים",
  leadsPipelineDesc: "שלבי צנרת מכירות — תצוגת פאנל אופקית",
  leadsPipelineBar: "לידים",
  viewAllLeads: "הצג את כל הלידים",
  activeLeads: "לידים פעילים",
  stageLead: "ליד",
  stageQualified: "מוסמך",
  stageProposal: "הצעה",
  stageNegotiation: "משא ומתן",
  stageClosedWon: "נסגר בהצלחה",
  stageClosedLost: "נסגר ללא הצלחה",
  // Team Widget
  teamTitle: "צוות",
  teamOnline: "מחוברים",
  teamBar: "מחוברים",
  // WATI Widget
  watiNoMessages: "אין הודעות חדשות",
  watiConfigNote: "הגדר NEXT_PUBLIC_WATI_URL לחיבור חי",
  // External Links Widget
  externalLinksLabelPlaceholder: "שם",
  externalLinksCancel: "ביטול",
  externalLinksAdd: "הוסף",
  externalLinksAddLink: "הוסף קישור",
  externalLinksReset: "איפוס",
  externalLinksBar: "קיצורים",
  // Today Widget
  todayLoading: "טוען...",
  todayNoEvents: "אין אירועים להיום.",
} as const;
export default widgets;
